/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import advocard from "../../../../assets/img/partner/logo_advocard.svg";
import arag from "../../../../assets/img/partner/logo_arag.svg";
import check from "../../../../assets/img/partner/logo_check24.svg";
import nrv from "../../../../assets/img/partner/logo_nrv.svg";
import wbs from "../../../../assets/img/partner/logo_wbs.svg";
import Typography from "@mui/material/Typography";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird";
import partnersSectionStyles from "./partnersSectionStyles";
import Grid from "@mui/material/Grid";
import { Box, Paper } from "@mui/material";
import Section from "@/src/components/Section/Section";

const partnerLogos = [
  {
    name: "Advocard",
    src: advocard,
  },
  {
    name: "Arag",
    src: arag,
  },
  {
    name: "NRV",
    src: nrv,
  },
  {
    name: "WBS",
    src: wbs,
  },
  {
    name: "CHECK24",
    src: check,
  },
];

const PartnersSection = () => {
  return (
    <Section>
      <Container variant={"lg"} showPaddingBlock={false}>
        <ChipLegalbird label={"Unsere Partner"} />

        <Typography variant={"h3"}>
          Gemeinsam sind wir für Sie da und <br /> setzen uns persönlich für Ihr Recht ein
        </Typography>

        <Grid container spacing={1} columns={10} sx={{ marginTop: "2rem" }}>
          {partnerLogos.map((logo) => (
            <Grid
              key={logo.name}
              size={{
                xs: 5,
                md: 2,
              }}
            >
              <Paper elevation={0} sx={partnersSectionStyles.logoContainer}>
                <Box component={"img"} src={logo.src} sx={partnersSectionStyles.logo} alt={"Logo " + logo.name} />
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default PartnersSection;
